import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { OrganisationService } from '@src/api';
import { AlertService } from '@src/core/services';

import { ImportData } from '../types';

@Injectable({
  providedIn: 'root',
})
export class ImportService {
  private readonly organisationService = inject(OrganisationService);
  private readonly alertService = inject(AlertService);

  private importData$ = new BehaviorSubject<ImportData | null>(null);

  startImport(data: ImportData) {
    this.importData$.next(data);
  }

  getResult() {
    return this.importData$.pipe(filter(request => !!request)).pipe(
      switchMap(request => {
        if (!!request) {
          return this.organisationService.importOrganisationFromExcel(request.files, undefined, 'response').pipe(
            catchError(err => {
              this.alertService.error(err);
              return of(null);
            }),
          );
        } else {
          return of(null);
        }
      }),
    );
  }

  clearImportData() {
    this.importData$.next(null);
  }
}
